<template>
  <div style="display: flex">
    <div class="image-cell">
      <div class="gc-list-record-icon-img" v-if="false">
        <!-- HasPrimaryImage -->
        <img :src="imgUrl" />
      </div>
      <div class="gc-list-record-icon">
        <!-- v-else -->
        {{ Description.charAt(0) }}
      </div>
    </div>
    <div class="gc-grid-item-container">
      <div class="gc-grid-description">
        {{ Description }}
      </div>
      <div class="gc-grid-code">{{ ItemCode }}</div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
// import ApiService from "../_services/api/api.service";

export default {
  props: {
    HasPrimaryImage: {
      type: Boolean,
      required: true,
      default: false,
    },
    ItemCode: {
      type: String,
      required: true,
    },
    Description: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      imageData: null,
      imgUrl: "",
    };
  },
  created() {
    // #27299 : No Images on grids until further notice
    // if (this.HasPrimaryImage) {
    //   ApiService.get("/api/ProductPrimaryImage?itemCode=" + this.ItemCode).then(
    //     (res) => {
    //       var src = "data:image;base64," + res.data.value;
    //       this.imgUrl = src;
    //       // eslint-disable-next-line no-console
    //       // this.$logger.debug("res ::", res);
    //     }
    //   );
    // }
  },
};
</script>

<style lang="scss" scoped>
.gc-list-record-icon {
  flex-basis: 33.5px;
  width: 33.5px;
  max-width: 33.5px;
  min-width: 33.5px;
  height: 33.5px;
  line-height: 33.5px;
  text-align: center;
  background-color: #20a4da;
  color: #ffffff;
  font-size: 15px;
  text-transform: uppercase;
  border: 1px solid #20a4da;
  border-radius: 50%;
  margin-left: 5px;
  overflow: hidden;
}
.gc-list-record-icon-img {
  flex-basis: 33.5px;
  width: 33.5px;
  max-width: 33.5px;
  min-width: 33.5px;
  height: 33.5px;
  line-height: 33.5px;
  text-align: center;
  color: white;
  font-size: 18px;
  border-radius: 50%;
  margin-left: 5px;
  overflow: hidden;
}

.gc-list-record-icon-img img {
  max-width: 33.5px;
  min-height: 33.5px;
}
</style>
